import { html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { BaseElement } from "../../utils/ui-components.js";
import { copyFileIcon } from "../../utils/icons.js";

@customElement("api-docs-code-block")
export class ApiDocsCodeBlock extends BaseElement {
    @property({ type: String }) code = "";

    @state() private copied = false;

    connectedCallback() {
        super.connectedCallback();
        this.style.display = "block";
    }

    private async copyToClipboard() {
        try {
            await navigator.clipboard.writeText(this.code);
            this.copied = true;
            setTimeout(() => {
                this.copied = false;
            }, 2000);
        } catch {
            // Silently fail — clipboard may not be available
        }
    }

    render() {
        return html`
            <div class="relative group">
                <pre class="bg-base-200 rounded-lg p-4 overflow-x-auto text-sm"><code>${this.code}</code></pre>
                <button
                    class="btn btn-sm btn-ghost absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity ${this.copied
                        ? "btn-success"
                        : ""}"
                    @click=${this.copyToClipboard}
                    title="Copy to clipboard"
                >
                    ${this.copied ? "Copied!" : html`<span class="w-4 h-4">${copyFileIcon}</span>`}
                </button>
            </div>
        `;
    }
}
